{
	"backToManageDeclarations": "Zpět na Správa prohlášení",
	"kpi": {
		"quantity": "Množství",
		"carbonSavings": "Redukce uhlíku"
	},
	"downloadAllDeclarations": "Stáhněte si všechna prohlášení",
	"errors": {
		"notFound": "Projekt nenalezen"
	}
}
